import type { MultimodalAssetDto } from '@scale/mm-shared';
import { makeStyles } from 'design-system/product/theme';
import { twMerge } from 'tailwind-merge';
import Pagination from 'react-scale/components/design-system/Pagination';
import { Icon, Spinner } from '@scale/scaleui';

type Props = {
  images: MultimodalAssetDto[];
  disabled?: boolean;
  setFocusedImage: (image: MultimodalAssetDto) => void;
  incrementClickedOn: (image_url: string) => Promise<void>;
  page: number;
  setPage: (i: number) => void;
  numPages: number;
  tableMode: boolean;
  isLoading: boolean;
};

const useStyles = makeStyles(() => ({
  imageContainer: {
    width: '400px',
    height: '400px',
    backgroundColor: 'white',
    '&:hover': {
      cursor: 'pointer',
      transform: 'scale(1.05)',
      boxShadow: '0 0 15px 2px rgba(0, 0, 0, 0.4)',
    },
  },
}));

const MMImageServiceAttachmentSearchResults = ({
  images,
  disabled,
  setFocusedImage,
  // incrementClickedOn, temporarily commented out to reduce pressure on multimodal server
  page,
  setPage,
  numPages,
  tableMode,
  isLoading,
}: Props) => {
  const classes = useStyles();
  if (isLoading) {
    return (
      <div className="flex justify-center items-center gap-4">
        <p>Loading results</p>
        <Spinner size="lg" />
      </div>
    );
  }

  return (
    <div
      className={`flex flex-wrap p-4 justify-center w-full max-h-full overflow-auto scale-tailwind ${
        tableMode ? '' : 'gap-4'
      }`}
    >
      {images.map(image => (
        <div
          key={image.image_url}
          className={twMerge(
            `flex items-center justify-center overflow-hidden border border-neutral-100 rounded-lg shadow-lg relative ${
              tableMode ? 'w-40 h-40' : ''
            }`,
            classes.imageContainer,
          )}
          onClick={async () => {
            if (!disabled) {
              setFocusedImage(image);
              // await incrementClickedOn(image.image_url);
            }
          }}
        >
          <img
            src={image.image_url}
            alt={image.image_category.join(' ')}
            className="object-cover max-w-full h-auto"
          />
          {image.added_to_task_count !== null &&
            image.added_to_task_count !== undefined &&
            image.added_to_task_count > 0 && (
              <Icon
                icon={['fas', 'crown']}
                size="lg"
                variant="info"
                className="absolute top-0 left-0"
                tooltip={'Popular Image'}
                tooltipProps={{
                  side: 'right',
                }}
              ></Icon>
            )}
        </div>
      ))}
      <div className={twMerge('w-[100%] p-2 text-center')}>
        <Pagination count={numPages} page={page} onChange={setPage} className="inline-flex" />
      </div>
    </div>
  );
};

export default MMImageServiceAttachmentSearchResults;
